import { Card } from "antd";
import { ContainerCard, CardStyle, images } from "../styles";

export default function GoldenGramado() {
  const { Meta } = Card;

  return (
    <ContainerCard>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/cronogramas/cronograma-golden-gramado.pdf">
            <img
              alt="cronograma"
              src={images.calendario}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Cronograma"
          description="Última atualização em: 12/09/2024"
        />
      </Card>

      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/autorizacao/autorizacao-golden-gramado.docx">
            <img
              alt="autorizacao"
              src={images.autorizacao}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Autorização de Hospedagem"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
    </ContainerCard>
  );
}
